module.exports = {
  immediate: 0,
  scheduled: 1,
};
